import React from 'react';
import {Box, Grid} from '@mui/material';
import UrunlerTable from './UrunlerTable';
import EksikUrunler from './components/EksikUrunler';
import HizliGiderEkle from './components/HizliGiderEkle';
import GunlukPersonelOzeti from './components/GunlukPersonelOzeti';

const LogbookHome = () => {
    const columnStyle = {
        height: 'calc(100vh - 180px)', // Üst bar, paddingler ve Grid spacing için pay artırıldı
        overflowY: 'auto',
        pr: 1, // Scroll bar için sağdan hafif boşluk
        '&::-webkit-scrollbar': {
            width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#ccc',
            borderRadius: '10px',
        },
    };

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <Box sx={columnStyle}>
                    <GunlukPersonelOzeti/>
                    <HizliGiderEkle/>
                    <EksikUrunler/>
                </Box>
            </Grid>
            <Grid item xs={12} md={6}>
                <Box sx={columnStyle}>
                    <UrunlerTable/>
                </Box>
            </Grid>
        </Grid>
    );
};

export default LogbookHome;
